import { useCallback, useEffect, useState } from "react";

import { adminApi, buildQuery } from "../services/adminApi";
import { getResults } from "../utils/formatters";

export default function useOrders(filters) {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const loadOrders = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      const payload = await adminApi(`/orders/${buildQuery(filters)}`);
      setOrders(getResults(payload));
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setIsLoading(false);
    }
  }, [filters]);

  const updateOrderStatus = useCallback(
    async (orderId, status) => {
      await adminApi(`/orders/${orderId}/`, {
        method: "PATCH",
        body: JSON.stringify({ status }),
      });
      await loadOrders();
    },
    [loadOrders],
  );

  useEffect(() => {
    loadOrders();
  }, [loadOrders]);

  return {
    error,
    isLoading,
    orders,
    reloadOrders: loadOrders,
    updateOrderStatus,
  };
}